import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, computed, input, signal } from '@angular/core';
import { VisaoControleResponse } from '@interfaces/corporate-registry/responses/rede-visoes.response';
import { RegistryGraphComponent } from '@shared/components/ownership-network/registry-graph/registry-graph.component';
import { injectOwnershipNetworkDisplay } from '@shared/components/ownership-network/ownership-network-display';

/**
 * Controle societário: cada estrutura (sócio PJ) já vem com o próprio grafo posicionado — aqui só se
 * escolhe qual mostrar. A troca é local, sem nova consulta.
 */
@Component({
  selector: 'app-registry-control',
  standalone: true,
  imports: [CommonModule, RegistryGraphComponent],
  templateUrl: './registry-control.component.html',
  styleUrl: './registry-control.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class RegistryControlComponent {
  protected readonly display = injectOwnershipNetworkDisplay();
  readonly visao = input.required<VisaoControleResponse>();
  protected readonly selecionada = signal<string | null>(null);

  protected readonly estrutura = computed(() => {
    const lista = this.visao().estruturas;
    return lista.find(e => e.socio.id === this.selecionada()) ?? lista[0] ?? null;
  });
}
